/* pageTop
========================================================= */
export function pageTop($) {
  const topBtn = $('#pagetop');
  topBtn.hide();

  // スクロールが100に達したらボタン表示
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
}
